import React, { PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNACard, DNAText, Iffy } from '@alucio/lux-ui';
import { DNAChip } from 'src/components/DNA';

const styles = StyleSheet.create({
  container: {
    borderRadius: 8,
    padding: 16,
  },
});

interface Props {
  actionsCount?: number
  headerRightSideComponent?: React.ReactElement
  titleRightSideComponent?: React.ReactElement
  title: string
}

const WidgetContainer: React.FC<PropsWithChildren<Props>> = (props) => {
  const { actionsCount, children, headerRightSideComponent, title, titleRightSideComponent } = props;

  return (
    <DNABox>
      <DNACard appearance="outline" style={styles.container}>
        <DNABox appearance="col" spacing="md">
          {/* HEADER */}
          <DNABox fill spacing="between" alignY='center'>
            <DNABox spacing="sm" alignY='center'>
              <DNAText h5>{title}</DNAText>
              <Iffy is={actionsCount}>
                <DNAChip.Beacon status='primary' appearance='filled' children={`${actionsCount}`} />
              </Iffy>
              <Iffy is={!!titleRightSideComponent}>
                {titleRightSideComponent}
              </Iffy>
            </DNABox>
            <DNABox>
              {headerRightSideComponent}
            </DNABox>
          </DNABox>
          {/* CONTENT */}
          {children &&
            <DNABox>{children}</DNABox>
          }
        </DNABox>
      </DNACard>
    </DNABox>
  );
};

export default WidgetContainer;
